import RequestUrls from '@Constants/RequestUrlsConstants';
import MessageBroker from '@Services/MessageBroker';

export const getFactContent = (payload) => MessageBroker.send(RequestUrls.FactSubstanceDetails, payload);

export const getDruglikenessContent = (payload) => MessageBroker.send(RequestUrls.DruglikenessSubstanceContent, payload);

export const getDruglikenessByXrn = (payload) => MessageBroker.send(RequestUrls.DruglikenessSubstanceDetails, payload);

export const getBioCategories = (payload) => MessageBroker.send(RequestUrls.BioSubstanceCategories, payload);

export const getBioPair = (payload) => MessageBroker.send(RequestUrls.BioSubstancePair, payload);

export const getBioContent = (payload) => MessageBroker.send(RequestUrls.BioSubstanceContent, payload);
